import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 12px;
    width: 100%;
`;

export const NativeCheckbox = styled.input`
    flex-shrink: 0;
    width: 18px;
    height: 18px;
    margin-top: 2px;
    cursor: pointer;
    accent-color: #232323;
`;

export const TextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
`;

export const Title = styled.label`
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    color: #232323;
    font-family: 'Inter', sans-serif;
    cursor: pointer;
`;

export const RequiredMark = styled.span`
    color: #f00;
    margin-left: 2px;
`;

export const Description = styled.p`
    margin: 0;
    font-size: 12px;
    font-weight: 400;
    color: #6b6b6b;
    font-family: 'Inter', sans-serif;
    white-space: pre-wrap;
`;
